import cn from 'classnames'
import { IconPlayDefault } from '@mc/design-system'
import { useVideo } from '@mc/video'

export const PlayOverlay = () => {
  const { play } = useVideo()
  return (
    <button
      onClick={() => play()}
      className={cn(
        'd-flex justify-content-center align-items-center mc-clickable position-absolute mc-inset-0',
      )}
    >
      <div
        style={{
          backgroundColor: 'var(--mc-color-play-default)',
          borderRadius: '50%',
        }}
        className='mc-p-5'
      >
        <IconPlayDefault size='lg' />
      </div>
    </button>
  )
}
